import { visuallyHiddenStyles, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.a `
  padding: ${theme.spacing.md};
  font-size: ${theme.fontSize.medium};
  font-weight: ${theme.fontWeight.semibold};
  line-height: ${theme.lineHeight.none};

  &:not(:focus-visible) {
    padding: 0;
    ${visuallyHiddenStyles};
  }
`;
